import axios, { AxiosError } from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "camaroo.Token";
const SESSION_KEY = "camaroo.Session";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t: string) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(SESSION_KEY); },
};

export const sessionStore = {
  get: <T,>(): T | null => {
    const s = localStorage.getItem(SESSION_KEY);
    if (!s) return null;

    try {
      return JSON.parse(s) as T;
    } catch {
      localStorage.removeItem(SESSION_KEY);
      return null;
    }
  },
  set: (s: unknown) => localStorage.setItem(SESSION_KEY, JSON.stringify(s)),
};

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = tokenStore.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError<{ Error?: string }>) => {
    if (err.response?.status === 401) {
      tokenStore.clear();
      if (window.location.pathname !== "/auth-login") window.location.assign("/auth-login");
    }
    return Promise.reject(err);
  },
);

/** Legacy ApiV2 envelope */
export interface ApiEnvelope<T = unknown> {
  Error: string | null;
  Msg?: string | null;
  Data?: T;
  EditLink?: string;
  EditAccess?: boolean;
  DeleteAccess?: boolean;
}

export function errorText(e: unknown): string {
  const err = e as AxiosError<{ Error?: string; Detail?: string }>;
  const d = err.response?.data;
  if (d?.Error === "Database Connection Error") {
    return "This function requires the central Admin database, which is not connected in this preview environment.";
  }
  if (d?.Error) return d.Detail ? `${d.Error} — ${d.Detail}` : d.Error;
  return err.message || "Request failed";
}
